import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface GlobalSearchTriggerProps {
  onClick: () => void;
}

/**
 * Search trigger button for the header
 * Shows search icon, text, and keyboard shortcut hint
 * Responsive: hides text on mobile
 */
export default function GlobalSearchTrigger({ onClick }: GlobalSearchTriggerProps) {
  // Detect OS for correct modifier key
  const isMac = typeof navigator !== 'undefined' && navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const modifierKey = isMac ? '⌘' : 'Ctrl';

  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex items-center gap-3 w-full max-w-2xl px-4 py-2.5 text-base text-gray-500 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors border border-gray-200 hover:border-gray-300"
    >
      <MagnifyingGlassIcon className="h-5 w-5 text-gray-400 group-hover:text-gray-500 flex-shrink-0" />
      <span className="flex-1 text-left text-gray-400 group-hover:text-gray-500">Search credentials, companies, folders...</span>
      <kbd className="hidden sm:inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-gray-400 bg-white border border-gray-200 rounded-md group-hover:border-gray-300 flex-shrink-0">
        {modifierKey}K
      </kbd>
    </button>
  );
}
